import axios from 'axios';
import { configs } from '../app/app-configs';
import { Product, ProductRequest, ProductSummary } from './model/store.model';

export const getProductSummary = async (): Promise<ProductSummary> => {
    return await axios
        .get(`${configs.BASE_URL}/products/summary`)
        .then((res) => {
            return res.data as ProductSummary;
        });
};

export const getProducts = async (): Promise<Product[]> => {
    return await axios.get(`${configs.BASE_URL}/products`).then((res) => {
        return res.data;
    });
};

export const createProduct = async (
    request: ProductRequest
): Promise<Product> => {
    return await axios
        .post(`${configs.BASE_URL}/products`, request)
        .then((res) => {
            return res.data as Product;
        });
};

export const updateProduct = async (
    request: ProductRequest
): Promise<Product> => {
    return await axios
        .put(`${configs.BASE_URL}/products/${request.id}`, request)
        .then((res) => {
            return res.data as Product;
        });
};

export const deleteProduct = async (id: number): Promise<number> => {
    return await axios
        .delete(`${configs.BASE_URL}/products/${id}`)
        .then((res) => {
            return res.data;
        });
};
